import AnketaItem from './AnketaItem';

export default AnketaItem;
